import { Component } from 'react';
import { getDisplayName } from 'utils/component';
import QuitOrderDialog from '../components/QuitOrderDialog';

export default function withQuitOrder(WrappedComponent) {
    class WithQuitOrder extends Component {
        constructor(props) {
            super(props);

            this.state = {
                showQuitOrderDialog: false,
                setAllowNavigation: null
            };

            this.openQuitOrderDialog = this.openQuitOrderDialog.bind(this);
            this.closeQuitOrderDialog = this.closeQuitOrderDialog.bind(this);
        }

        openQuitOrderDialog(setAllowNavigation) {
            this.setState({
                showQuitOrderDialog: true,
                setAllowNavigation
            });
        }

        closeQuitOrderDialog() {
            this.setState({ showQuitOrderDialog: false });
        }

        render() {
            const { showQuitOrderDialog, setAllowNavigation } = this.state;

            return (
                <>
                    <WrappedComponent openQuitOrderDialog={this.openQuitOrderDialog} {...this.props} />

                    {showQuitOrderDialog && (
                        <QuitOrderDialog
                            setAllowNavigation={setAllowNavigation}
                            closeDialog={this.closeQuitOrderDialog}
                        />
                    )}
                </>
            );
        }
    }

    WithQuitOrder.displayName = `WithQuitOrder(${getDisplayName(WrappedComponent)})`;

    return WithQuitOrder;
}
